import styled from '@emotion/styled';
import { styled as zds } from '@zoopla-eng/zds-components/themes';
import { css } from '@emotion/react';
import { ButtonLink } from '@blueprint/ui';

export const HeadingRow = zds('div', {
    marginBottom: '$S500',
    display: 'flex',
    alignItems: 'center',
    paddingRight: '$S200'
});

export const StyledCenteringDiv = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        justify-content: center;
        ${ButtonLink} svg {
            margin-left: ${spacing['8px']};
        }
    `
);
